import PropTypes from 'prop-types'
import React from 'react'

import PropTypesHelpers from '../../utils/propTypesHelpers'

const FieldFeedback = ({ valid, invalid, children }) => (
  <>
    {children}
    {valid &&
      <div className='valid-feedback'>{valid}</div>}
    {invalid &&
      <div className='qa-invalid-feedback invalid-feedback'>{invalid}</div>}
  </>
)

FieldFeedback.propTypes = {
  children: PropTypesHelpers.children,
  valid: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  invalid: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
}

export default FieldFeedback
